import { customers } from "@wayke-se/ecom";
import { validateCustomerObjectPersonalNumber } from "../tools/data-validation";
import { createCustomerObject } from "../tools/data-creator";
const validate = (data) => {
    const customerObject = createCustomerObject(data, null);
    return validateCustomerObjectPersonalNumber(customerObject);
};
export const getAddressLookup = (data, callback) => {
    const isValidRequestData = validate(data.ecomData);
    if (!isValidRequestData) {
        return callback(null);
    }
    const request = customers
        .newAddressLookupRequest()
        .forCustomer(data.ecomData.personalNumber)
        .build();
    customers
        .lookupAddress(request)
        .then((response) => {
        callback(response);
    })
        .catch(() => {
        callback(null);
    });
};
